/** @jsx jsx */
import { jsx } from '@emotion/react';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { DropdownItem, DropdownButton } from '@airwallex/dropdown';
import SwitchLanguage from '@/assets/svgs/switchLanguage.svg';
import { LANGUAGE_OPTIONS, SUPPORT_LANGUAGES } from '@/utils/language';

export const Index: FC = () => {
  const { i18n } = useTranslation();
  const dropdownButton = useRef();
  const dropdownButtonRef = dropdownButton?.current as {
    closeMenu: () => void;
  };

  return (
    <div>
      <DropdownButton icon={SwitchLanguage} responsive menuRight iconPosition="right" ref={dropdownButton}>
        <DropdownItem
          onClick={() => {
            i18n.changeLanguage(SUPPORT_LANGUAGES.zh);
            dropdownButtonRef?.closeMenu();
          }}
        >
          {LANGUAGE_OPTIONS.find((option) => option.value === SUPPORT_LANGUAGES.zh)?.label}
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            i18n.changeLanguage(SUPPORT_LANGUAGES.en);
            dropdownButtonRef?.closeMenu();
          }}
        >
          {LANGUAGE_OPTIONS.find((option) => option.value === SUPPORT_LANGUAGES.en)?.label}
        </DropdownItem>
      </DropdownButton>
    </div>
  );
};

export default Index;
